<script>
import Languages from "../../lang/lang";

export default {
  name: 'FarmSummary',
  props: ['data', 'btcPrice'],
  computed: {
    lang() {
      return Languages.texts('farmSummary');
    },
    title() {
      return Languages.texts('farmSummary')['title'].replace('%', this.data.title);
    },
    yesterday() {
      if (this.data.yesterdayIncome > 0) {
        return '+' + this.data.yesterdayIncome;
      } else {
        return '0';
      }
    },
    yesterdayUsd() {
      if (this.data.yesterdayIncome > 0) {
        return window['formatBigDollar'](this.data.yesterdayIncome * this.btcPrice, 2);
      } else {
        return '$0';
      }
    },
    total() {
      if (this.data.totalIncome > 0) {
        return this.data.totalIncome;
      } else {
        return '0';
      }
    },
    totalUsd() {
      if (this.data.totalIncome > 0) {
        return window['formatBigDollar'](this.data.totalIncome * this.btcPrice, 2);
      } else {
        return '$0';
      }
    },
    deposit() {
      return window['formatBigDollar'](this.data.userDeposit, 2);
    },
    share() {
      return this.data.share * 100;
    },
  }
}
</script>

<template>
  <div class="summary farm-summary">
    <div class="block-title" v-html="title">
    </div>
    <div class="blocks">
      <div class="block">
        <div>
          <div class="item-title">{{ lang['yesterday'] }}:</div>
          <div class="item-value gold-gradient btc">
            <span>{{ yesterday }} BTC</span>
          </div>
          <div class="item-value usd">&asymp; {{ yesterdayUsd }}</div>
        </div>
        <div>
          <div class="item-title">{{ lang['total'] }}:</div>
          <div class="item-value gold-gradient btc">
            <span>{{ total }} BTC</span>
          </div>
          <div class="item-value usd">&asymp; {{ totalUsd }}</div>
        </div>
        <router-link :to="'/farm/' + data.id + '/income'" class="btn btn-simple">
          Income history
        </router-link>
      </div>
      <div class="block">
        <div>
          <div class="item-title">{{ lang['deposit'] }}:</div>
          <div class="item-value gold-gradient btc">
            <span>{{ deposit }}</span>
          </div>
          <div class="item-value gray">&nbsp;</div>
        </div>
        <div>
          <div class="item-title">{{ lang['stake'] }}:</div>
          <div class="item-value gold-gradient btc">
            <span>{{ share }}%</span>
          </div>
          <div class="item-value gray">&nbsp;</div>
        </div>

        <router-link :to="'/farm/' + data.id + '/orders'" class="btn btn-simple">
          Order records
        </router-link>
      </div>
    </div>
  </div>
</template>